<template>
  <v-container>
    <h3>サーベイ集計</h3>
    <v-btn color="cyan" class="white--text"  @click="aggregate_all()" style="margin: 0.5rem 0;">
      <v-icon color="white">functions</v-icon>集計
    </v-btn>
    <v-data-table
      :items="subject_answers"
      :headers="headers"
      class="elevation-1"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      rows-per-page-text="表示行"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{props.index + 1}}</td>
          <td>{{props.item.name}}</td>
          <td>{{props.item.status}}</td>
          <td>{{props.item.coWorker_finished_count}}</td>
          <td>

          </td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="props"
      >{{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示</template>
    </v-data-table>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import { unixtimeToFormattedDate, getMoment } from "@/utils/datetime.js";
import { mapMutations } from "vuex";
import questions from "@/master/questions.json";


export default {
  components: {
  },
  data() {
    return {
      dbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id),
      subject_answers: [],
      answers: [],
      rowsPerPageItems: [25, 50, 100],
      pagination: {
        rowsPerPage: 50
      },
      headers: [
        { text: "No.", value: "name", sortable: false },
        { text: "対象者名", value: "name", sortable: true },
        { text: "ステータス", value: "status", sortable: true },
        { text: "協力者回答数", value: "coWorker_finished_count", sortable: true },
        { text: "操作", sortable: false }
      ],
      categories: [],
      selectOptions: [],
      summaryItems: {},
      survey: {},
      questions: [],
      selectSections: [],
      commentSections: [],
    };
  },
  created() {
  },
  mounted() {
    this.getAnswers();
    this.getSurvey();
  },
  methods: {
    
    getAnswers(){
      const coWorker_answers = [];
      this.dbRef
        .collection("answer_sheets")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const answer = doc.data();
            if ((answer.status && answer.status == "完了") || answer.status == "完了前") {
              this.answers.push(answer);
            } 
            if(answer.type === "subject"){
              this.subject_answers.push(answer);
            }else if(answer.type === "coWorker"){
              coWorker_answers.push(answer);
            }
          });
          this.subject_answers.forEach(subject_answer => {
            const coWorkers = coWorker_answers.filter(coWorker_answer => coWorker_answer.subject_id === subject_answer.subject_id);
            if(coWorker_answers && coWorker_answers.length > 0){
              subject_answer.coWorker_answer = coWorkers.filter(coWorker_answer => coWorker_answer.status == '完了' || coWorker_answer.status == '完了前');
              subject_answer.coWorker_finished_count = subject_answer.coWorker_answer.length;
            }
          });
        }).catch(error => {
          console.log(error);
        });
    },
    async getSurvey() {
      const doc = await this.dbRef.get();
      this.survey = doc.data();
      this.commentSections = { index: [] };
      this.questions = [];
      this.survey.question_sheet.sections
        .filter((s, i) => {
          if (s.type == "SelectQuestions") {
            this.selectSections.push(i);
            return true;
          } else if (s.type == "CommentQuestions") {
            this.commentSections.index.push(i);
            this.commentSections[i] = {
              isShow: s.isShow,
              comments: { subject: [], coWorker: [] },
            };
          }
        }, this)
        .forEach((s) => {
          s.questions.forEach((q) => this.questions.push(q));
        });
      this.categories =
        this.survey.question_sheet.sections[
          this.selectSections[0]
        ].categoryList;
      this.categories.forEach((c) => {
        this.summaryItems[c] = { category: c, selfs: [], score: [] };
      });
      this.selectOptions =
        this.survey.question_sheet.sections[
          this.selectSections[0]
        ].selectOptions;
    },
    aggregate_all(){
      debugger
      this.changeLoadingState(true);
      this.subject_answers.forEach(subject_answer => {
        if(subject_answer.status == '完了' || subject_answer.status == '完了前'){
          this.aggregate(subject_answer);
        }
      });
      this.changeLoadingState(false);

    },
    aggregate(subjectAns) {
      debugger
      const coWorkerAns = subjectAns.coWorker_answer;;
      const summaryItems = JSON.parse(JSON.stringify(this.summaryItems));
      const commentSections = JSON.parse(JSON.stringify(this.commentSections));
      const infoItems = {
        subjectName: "",
        startDate: "",
        endDate: "",
        numOfCoWorker: 0,
      }

      //account select questions
      const items = this.questions.map((q) => {
        const score = [];
        coWorkerAns.forEach((a) => {
          if (a.result[this.selectSections[0]][q.id]) {
            const s = Number(a.result[this.selectSections[0]][q.id]);
            summaryItems[q.category].score.push(s);
            score.push(s);
          }
        }, this);
        const self = Number(subjectAns.result[this.selectSections[0]][q.id]);

        summaryItems[q.category].selfs.push(self);

        return {
          id: q.id,
          question: q.question,
          category: q.category,
          score: score,
          self: self,
        };
      });

      //account coWorker's comments
      coWorkerAns.forEach((a) => {
        commentSections.index.forEach((i) => {
          if (a.result[i].length > 0) {
            commentSections[i].comments.coWorker.push(
              ...a.result[i].filter((c) => c.trim().length > 0)
            );
          }
          //Random sort comments
          for (
            let j = commentSections[i].comments.coWorker.length - 1;
            j > 0;
            j--
          ) {
            const rand = Math.floor(Math.random() * (j + 1));
            [
              commentSections[i].comments.coWorker[j],
              commentSections[i].comments.coWorker[rand],
            ] = [
              commentSections[i].comments.coWorker[rand],
              commentSections[i].comments.coWorker[j],
            ];
          }
        });
      });

      //account subject's comments
      commentSections.index.forEach((i) => {
        if (subjectAns.result[i].length > 0) {
          commentSections[i].comments.subject.push(
            ...subjectAns.result[i].filter((c) => c.length > 0)
          );
        }
      });

      //account info table
      infoItems.subjectName = subjectAns.subject_name;
      infoItems.startDate = this.survey.start_date;
      infoItems.endDate = this.survey.pre_end_date;
      infoItems.numOfCoWorker = coWorkerAns.length;

      const subjectInfo = JSON.parse(JSON.stringify(subjectAns));
      delete subjectInfo.result;

      const result = {
        select_questions: items,
        select_options: this.selectOptions,
        select_categories: this.categories,
        comment_questions: commentSections,
        summary: summaryItems,
        info: infoItems,
        subject: subjectInfo,
      };
      console.log(result)
      this.dbRef
        .collection("results")
        .doc(subjectAns.subject_id)
        .set(result)
        .then((doc) => {})
        .catch((e) => {
          console.error(e);
        });
    },
    ...mapMutations("app", ["changeLoadingState"])
  }
};
</script>
<style lang="scss" scoped>
</style>